module.exports = "/_next/static/images/7cc932a2a316fa957fe887c1d7a9d9d3-slide-4-large.png.webp";